import React from "react"

interface DragHandleProps {
  /** Whether the drag is past the dismiss threshold */
  isPastThreshold: boolean
  /** Progress of the drag from 0 to 1 */
  dragProgress: number
}

/**
 * Drag handle component that provides visual feedback during drag gestures
 */
export const DragHandle: React.FC<DragHandleProps> = ({ isPastThreshold, dragProgress }) => {
  // Ensure dragProgress is a valid number
  const validDragProgress = typeof dragProgress === "number" && !isNaN(dragProgress) ? dragProgress : 0

  return (
    <div className="flex h-6 items-center justify-center">
      <div
        className={`h-1 rounded-full transition-all duration-150 ${
          isPastThreshold ? "bg-yellow-600" : validDragProgress > 0 ? "bg-gray-600" : "bg-gray-700"
        }`}
        style={{
          width: `${Math.max(12 + validDragProgress * 20, 12)}px`,
          transform: isPastThreshold
            ? "scaleY(1.3)"
            : validDragProgress > 0
              ? `scaleY(${1 + validDragProgress * 0.2})`
              : "scaleY(1)",
          opacity: isPastThreshold ? 1 : Math.min(0.8 + validDragProgress * 0.2, 1)
        }}
      />
    </div>
  )
}

export default DragHandle
